// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Editor-module__editor__yicNO {
  padding: 0;
  background: #fff;
  border-right: 2px solid #ebebf2;
  transition: width 200ms ease-in-out;
  height: inherit;
  flex-basis: 100%;
  max-width: 100%;
}
.Editor-module__editor__yicNO .ant-tabs-tabpane-active {
  height: 100%;
}
.Editor-module__editor-MINI_PLAYGROUND__gSo9Z {
  border-right: none;
}
.Editor-module__editor-MINI_PLAYGROUND__gSo9Z .ant-tabs-content-holder {
  height: 350px;
}
.Editor-module__editor-PROCESS_RUN__BwVDN .ant-tabs-content {
  height: calc(100vh - 180px);
}
.Editor-module__editor-PLAYGROUND__vgfYb .ant-tabs-content {
  height: calc(100vh - 225px);
  overflow: scroll;
}
.Editor-module__opacity__GcCzp {
  opacity: 0.8;
}
.Editor-module__editorLine__PhaKU {
  padding: 1px 15px 1px 15px;
  white-space: pre-wrap;
  position: relative;
  border-bottom: 1px solid #ebf2f4;
  border-radius: 2px;
  transition: all 225ms cubic-bezier(0, 0, 0.2, 1);
  margin-left: 17px;
  display: block;
}
.Editor-module__editorLine__PhaKU.Editor-module__active__Oi08w {
  background: rgba(102, 30, 255, 0.1);
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.16);
}
.Editor-module__editorLine__PhaKU:hover {
  background: #f5f5fa;
}
.Editor-module__editorLine__PhaKU .menuIcon {
  visibility: hidden;
  margin-left: 8px;
}
.Editor-module__editorLine__PhaKU:hover .menuIcon {
  visibility: visible;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k {
  text-align: right;
  width: 23px;
  position: absolute;
  top: 16px;
  transform: translateY(-50%);
  color: #999;
  font-family: 'Source Code Pro', monospace;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 13px;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k::before {
  content: '';
  position: absolute;
  top: 0;
  left: -50px;
  width: 50px;
  height: 100%;
  background-color: transparent;
  z-index: 2;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__markerPosition__eqio6 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #818199;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__debugMark__YpotV {
  left: -35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 3;
  display: none;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__mark___VWws {
  left: -35px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: none;
  cursor: pointer;
  z-index: 3;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__startMark__FL0YY {
  background-color: #26ab62;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__pauseMark__WIhWa {
  background-color: #ff4444;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k:hover .Editor-module__debugMark__YpotV {
  display: block;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__markContainer__YKLJS {
  left: -30px;
  display: flex;
  z-index: 3;
  background-color: #f5f5fa;
  justify-content: space-around;
  align-items: center;
  padding: 2px 5px;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__markContainer__YKLJS .Editor-module__startPlay__Ydtow {
  margin-right: 10px;
  cursor: pointer;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__markContainer__YKLJS .Editor-module__pause__RUy7u {
  cursor: pointer;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineNumber__zP48k .Editor-module__markerVisible__WDBSe {
  display: block;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorRightLine__or_tK {
  position: absolute;
  top: 0;
  width: 2.5px;
  height: calc(100% + 4px);
  background-color: #f2f2f2;
  z-index: 1;
}
.Editor-module__editorLine__PhaKU::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2.5px;
  height: 100%;
  background-color: #adc3cd;
  z-index: 2;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineDetails__ewqh4 {
  display: flex;
  align-items: center;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineInput__fauf_ {
  padding: 5px 3px;
  max-width: calc(100% - 100px);
  font-family: 'Source Code Pro', monospace;
  flex-basis: 100%;
  position: relative;
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineInput__fauf_ .Editor-module__autoPilotContainer___OAA9 {
  color: #597688;
  font-family: Nunito;
  font-size: 11px;
  font-style: italic;
  font-weight: 400;
  line-height: 18px;
  /* 180% */
}
.Editor-module__editorLine__PhaKU .Editor-module__editorLineInput__fauf_ .Editor-module__autoPilotContainer___OAA9 .Editor-module__userWrittenContent__JPIwJ {
  font-style: normal;
}
.Editor-module__editorLine__PhaKU .Editor-module__lineOutput__LK156 {
  display: flex;
}
.Editor-module__editorLine__PhaKU .ant-btn-circle {
  height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.Editor-module__editorLine__PhaKU .ant-btn-circle:last-child {
  margin-right: 0;
}
.Editor-module__editorLine__PhaKU .Editor-module__exceptionMarker__V1Wfp {
  color: #cf2a38;
  cursor: pointer;
  margin-right: 10px;
}
.Editor-module__editorLine-MINI_PLAYGROUND__ybRbW {
  padding: 1px 8px 1px 8px;
}
.Editor-module__lineErrorIcon__aegmW {
  color: #cf2a38;
  margin-right: 10px;
  position: absolute;
  left: -38px;
  font-size: 12px;
  z-index: 3;
}
.Editor-module__lineError___ct36 {
  border-bottom: 1px solid #cf2a38;
}
.Editor-module__error__fzwV3::before {
  background-color: #cf2a38;
}
.editorErrorLineLast {
  background-color: #ffeeba !important;
}
.Editor-module__success__dMBjL::before {
  background-color: #26ab62;
}
.Editor-module__warning__HNc_2::before {
  background-color: #e9b825;
}
.Editor-module__editorLineActions__x9tIj {
  display: flex;
  align-items: center;
}
.Editor-module__editorLineActions__x9tIj .Editor-module__autoPilotSVGContainer__VVzCL {
  width: 20px;
  height: 20px;
  padding: 2px;
  margin-right: 2px;
  background-color: white;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.Editor-module__editorLineActions__x9tIj .Editor-module__autoPilotSVGContainer__VVzCL:hover {
  background-color: #dfe7ea;
}
.Editor-module__editorTab__q4JDD .ant-tabs-tab {
  padding: 6px 0;
}
.Editor-module__editorTab__q4JDD .ant-tabs-nav {
  padding: 0px 5px;
  margin: 0 0 6px 0;
}
.Editor-module__editorTab__q4JDD .ant-tabs-tab:first-child {
  margin: 0 18px 0 0px !important;
}
.Editor-module__editorTab__q4JDD .ant-tabs-tab + .ant-tabs-tab {
  margin: 0 0 0 10px !important;
}
.Editor-module__hideTabNav__FslY2 .ant-tabs-nav {
  display: none;
}
.Editor-module__autopilotScaleAnimation__UOt5H {
  animation: Editor-module__scale__nk7Tc 5s ease-in-out forwards;
}
@keyframes Editor-module__scale__nk7Tc {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1);
  }
  70% {
    transform: scale(2);
  }
  73% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}
.Editor-module__tab__omHfw .Editor-module__tabClose__Qm9ZO {
  font-size: 11px;
  margin-left: 8px;
  opacity: 0;
}
.Editor-module__tab__omHfw:hover .Editor-module__tabClose__Qm9ZO {
  opacity: 1;
}
.Editor-module__foldIcon__CDLaE {
  font-size: 12px;
  color: #777;
  margin-left: 8px;
  cursor: pointer;
  transition: all 225ms cubic-bezier(0, 0, 0.2, 1);
}
.Editor-module__collapsedBlock__w2Czm {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.Editor-module__collapsedBlock__w2Czm::after {
  content: '...';
  display: flex;
  align-items: flex-end;
  font-size: 13px;
  height: 15px;
  background-color: #d9d9d9;
  color: #597688;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PlaygroundV3/components/Editor/Editor.module.less"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,gBAAA;EACA,+BAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACF;AARA;EAUI,YAAA;AACJ;AAGA;EACE,kBAAA;AADF;AAAA;EAII,aAAA;AADJ;AAKA;EAEI,2BAAA;AAJJ;AAOA;EAEI,2BAAA;EACA,gBAAA;AANJ;AAeA;EACE,YAAA;AAbF;AAgBA;EACE,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gDAAA;EACA,iBAAA;EACA,cAAA;AAdF;AAgBE;EACE,mCAAA;EACA,2CAAA;AAdJ;AAiBE;EACE,mBAAA;AAfJ;AADA;EAoBI,kBAAA;EACA,gBAAA;AAhBJ;AAmBE;EAEI,mBAAA;AAlBN;AARA;EA+BI,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,yCAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AApBJ;AAsBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;AApBN;AA/BA;EAuDM,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AArBN;AArCA;EA8DM,WAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAtBN;AA5CA;EAsEM,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;AAvBN;AArDA;EA+EM,yBAAA;AAvBN;AAxDA;EAmFM,yBAAA;AAxBN;AA2BI;EAEI,cAAA;AA1BR;AA9DA;EA6FM,WAAA;EACA,aAAA;EAEA,UAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AA7BN;AAvEA;EAuGQ,kBAAA;EACA,eAAA;AA7BR;AA3EA;EA2GQ,eAAA;AA7BR;AA9EA;EAgHM,cAAA;AA/BN;AAjFA;EAqHI,kBAAA;EACA,MAAA;EACA,YAAA;EACA,wBAAA;EACA,yBAAA;EACA,UAAA;AAjCJ;AAoCE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;AAlCJ;AAnGA;EAoJI,aAAA;EACA,mBAAA;AA9CJ;AAvGA;EAyJI,gBAAA;EACA,6BAAA;EACA,yCAAA;EACA,gBAAA;EACA,kBAAA;AA/CJ;AA9GA;EAgKM,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EA/CJ,SAAS;AACX;AAvHA;EAwKQ,kBAAA;AA9CR;AA1HA;EA8KI,aAAA;AAjDJ;AA7HA;EAkLI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAlDJ;AAoDI;EACE,eAAA;AAlDN;AAxIA;EA+LI,cAAA;EACA,eAAA;EACA,kBAAA;AApDJ;AAwDA;EACE,wBAAA;AAtDF;AAyDA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAvDF;AAyDA;EACE,gCAAA;AAvDF;AA2DE;EACE,yBAAA;AAzDJ;AA8DA;EACE,oCAAA;AA5DF;AAgEE;EACE,yBAAA;AA9DJ;AAkEE;EACE,yBAAA;AAhEJ;AAoEA;EACE,aAAA;EACA,mBAAA;AAlEF;AAgEA;EAKI,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAlEJ;AAoEI;EACE,yBAAA;AAlEN;AAuEA;EAEI,cAAA;AAtEJ;AAoEA;EAKI,gBAAA;EACA,iBAAA;AAtEJ;AAgEA;EASI,+BAAA;AAtEJ;AA6DA;EAaI,6BAAA;AAvEJ;AA2EA;EAEI,aAAA;AA1EJ;AA8EA;EACE,8DAAA;AA5EF;AA+EA;EACE;IACE,mBAAA;EA7EF;EA+EA;IACE,mBAAA;EA7EF;EA+EA;IACE,mBAAA;EA7EF;EA+EA;IACE,mBAAA;EA7EF;EA+EA;IACE,mBAAA;EA7EF;AACF;AAgFA;EAEI,eAAA;EACA,gBAAA;EACA,UAAA;AA/EJ;AAkFE;EAEI,UAAA;AAjFN;AAsFA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gDAAA;AApFF;AAuFA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AArFF;AAuFA;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AArFF","sourcesContent":[".editor {\n  padding: 0;\n  background: #fff;\n  border-right: 2px solid #ebebf2;\n  transition: width 200ms ease-in-out;\n  height: inherit;\n  flex-basis: 100%;\n  max-width: 100%;\n\n  :global(.ant-tabs-tabpane-active) {\n    height: 100%;\n  }\n}\n\n.editor-MINI_PLAYGROUND {\n  border-right: none;\n\n  :global(.ant-tabs-content-holder) {\n    height: 350px;\n  }\n}\n\n.editor-PROCESS_RUN {\n  :global(.ant-tabs-content) {\n    height: calc(100vh - 180px);\n  }\n}\n.editor-PLAYGROUND {\n  :global(.ant-tabs-content) {\n    height: calc(100vh - 225px);\n    overflow: scroll;\n  }\n}\n\n.editorContent {\n  // height: calc(100% - 55px);\n  // overflow: auto;\n}\n\n.opacity {\n  opacity: 0.8;\n}\n\n.editorLine {\n  padding: 1px 15px 1px 15px;\n  white-space: pre-wrap;\n  position: relative;\n  border-bottom: 1px solid #ebf2f4;\n  border-radius: 2px;\n  transition: all 225ms cubic-bezier(0, 0, 0.2, 1);\n  margin-left: 17px;\n  display: block;\n\n  &.active {\n    background: rgba(102, 30, 255, 0.1);\n    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.16);\n  }\n\n  &:hover {\n    background: #f5f5fa;\n  }\n\n  :global(.menuIcon) {\n    visibility: hidden;\n    margin-left: 8px;\n  }\n\n  &:hover {\n    :global(.menuIcon) {\n      visibility: visible;\n    }\n  }\n\n  .editorLineNumber {\n    text-align: right;\n    width: 23px;\n    position: absolute;\n    top: 16px;\n    transform: translateY(-50%);\n    color: #999;\n    font-family: 'Source Code Pro', monospace;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    font-size: 13px;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -50px;\n      width: 50px;\n      height: 100%;\n      background-color: transparent;\n      z-index: 2;\n    }\n\n    .markerPosition {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      color: #818199;\n    }\n\n    .debugMark {\n      left: -35px;\n      border-radius: 50%;\n      cursor: pointer;\n      z-index: 3;\n      display: none;\n    }\n\n    .mark {\n      left: -35px;\n      width: 9px;\n      height: 9px;\n      border-radius: 50%;\n      display: none;\n      cursor: pointer;\n      z-index: 3;\n    }\n    .startMark {\n      background-color: #26ab62;\n    }\n\n    .pauseMark {\n      background-color: #ff4444;\n    }\n\n    &:hover {\n      .debugMark {\n        display: block;\n      }\n    }\n\n    .markContainer {\n      left: -30px;\n      display: flex;\n      align-items: center;\n      z-index: 3;\n      background-color: #f5f5fa;\n      justify-content: space-around;\n      align-items: center;\n      padding: 2px 5px;\n\n      .startPlay {\n        margin-right: 10px;\n        cursor: pointer;\n      }\n      .pause {\n        cursor: pointer;\n      }\n    }\n\n    .markerVisible {\n      display: block;\n    }\n  }\n\n  .editorRightLine {\n    position: absolute;\n    top: 0;\n    width: 2.5px;\n    height: calc(100% + 4px);\n    background-color: #f2f2f2;\n    z-index: 1;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 2.5px;\n    height: 100%;\n    background-color: #adc3cd;\n    z-index: 2;\n  }\n\n  // &::after {\n  //   content: '';\n  //   position: absolute;\n  //   top: 0;\n  //   left: 0;\n  //   height: calc(100% + 4px);\n  //   background-color: #c499ff;\n  //   z-index: 1;\n  //   width: 2.5px;\n  // }\n\n  .editorLineDetails {\n    display: flex;\n    align-items: center;\n  }\n\n  .editorLineInput {\n    padding: 5px 3px;\n    max-width: calc(100% - 100px);\n    font-family: 'Source Code Pro', monospace;\n    flex-basis: 100%;\n    position: relative;\n\n    .autoPilotContainer {\n      color: #597688;\n      font-family: Nunito;\n      font-size: 11px;\n      font-style: italic;\n      font-weight: 400;\n      line-height: 18px; /* 180% */\n\n      .userWrittenContent {\n        font-style: normal;\n      }\n    }\n  }\n\n  .lineOutput {\n    display: flex;\n  }\n  :global(.ant-btn-circle) {\n    height: 26px;\n    height: 26px;\n    width: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 5px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  .exceptionMarker {\n    color: #cf2a38;\n    cursor: pointer;\n    margin-right: 10px;\n  }\n}\n\n.editorLine-MINI_PLAYGROUND {\n  padding: 1px 8px 1px 8px;\n}\n\n.lineErrorIcon {\n  color: #cf2a38;\n  margin-right: 10px;\n  position: absolute;\n  left: -38px;\n  font-size: 12px;\n  z-index: 3;\n}\n.lineError {\n  border-bottom: 1px solid #cf2a38;\n}\n\n.error {\n  &::before {\n    background-color: #cf2a38;\n  }\n}\n\n// TODO: Remove global styles\n:global(.editorErrorLineLast) {\n  background-color: #ffeeba !important;\n}\n\n.success {\n  &::before {\n    background-color: #26ab62;\n  }\n}\n.warning {\n  &::before {\n    background-color: #e9b825;\n  }\n}\n\n.editorLineActions {\n  display: flex;\n  align-items: center;\n\n  .autoPilotSVGContainer {\n    width: 20px;\n    height: 20px;\n    padding: 2px;\n    margin-right: 2px;\n    background-color: white;\n    border-radius: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #dfe7ea;\n    }\n  }\n}\n\n.editorTab {\n  :global(.ant-tabs-tab) {\n    padding: 6px 0;\n  }\n  :global(.ant-tabs-nav) {\n    padding: 0px 5px;\n    margin: 0 0 6px 0;\n  }\n  :global(.ant-tabs-tab):first-child {\n    margin: 0 18px 0 0px !important;\n  }\n\n  :global(.ant-tabs-tab + .ant-tabs-tab) {\n    margin: 0 0 0 10px !important;\n  }\n}\n\n.hideTabNav {\n  :global(.ant-tabs-nav) {\n    display: none;\n  }\n}\n\n.autopilotScaleAnimation {\n  animation: scale 5s ease-in-out forwards;\n}\n\n@keyframes scale {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1);\n  }\n  70% {\n    transform: scale(2);\n  }\n  73% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.tab {\n  .tabClose {\n    font-size: 11px;\n    margin-left: 8px;\n    opacity: 0;\n  }\n\n  &:hover {\n    .tabClose {\n      opacity: 1;\n    }\n  }\n}\n\n.foldIcon {\n  font-size: 12px;\n  color: #777;\n  margin-left: 8px;\n  cursor: pointer;\n  transition: all 225ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.collapsedBlock {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.collapsedBlock::after {\n  content: '...';\n  display: flex;\n  align-items: flex-end;\n  font-size: 13px;\n  height: 15px;\n  background-color: #d9d9d9;\n  color: #597688;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `Editor-module__editor__yicNO`,
	"editor-MINI_PLAYGROUND": `Editor-module__editor-MINI_PLAYGROUND__gSo9Z`,
	"editor-PROCESS_RUN": `Editor-module__editor-PROCESS_RUN__BwVDN`,
	"editor-PLAYGROUND": `Editor-module__editor-PLAYGROUND__vgfYb`,
	"opacity": `Editor-module__opacity__GcCzp`,
	"editorLine": `Editor-module__editorLine__PhaKU`,
	"active": `Editor-module__active__Oi08w`,
	"editorLineNumber": `Editor-module__editorLineNumber__zP48k`,
	"markerPosition": `Editor-module__markerPosition__eqio6`,
	"debugMark": `Editor-module__debugMark__YpotV`,
	"mark": `Editor-module__mark___VWws`,
	"startMark": `Editor-module__startMark__FL0YY`,
	"pauseMark": `Editor-module__pauseMark__WIhWa`,
	"markContainer": `Editor-module__markContainer__YKLJS`,
	"startPlay": `Editor-module__startPlay__Ydtow`,
	"pause": `Editor-module__pause__RUy7u`,
	"markerVisible": `Editor-module__markerVisible__WDBSe`,
	"editorRightLine": `Editor-module__editorRightLine__or_tK`,
	"editorLineDetails": `Editor-module__editorLineDetails__ewqh4`,
	"editorLineInput": `Editor-module__editorLineInput__fauf_`,
	"autoPilotContainer": `Editor-module__autoPilotContainer___OAA9`,
	"userWrittenContent": `Editor-module__userWrittenContent__JPIwJ`,
	"lineOutput": `Editor-module__lineOutput__LK156`,
	"exceptionMarker": `Editor-module__exceptionMarker__V1Wfp`,
	"editorLine-MINI_PLAYGROUND": `Editor-module__editorLine-MINI_PLAYGROUND__ybRbW`,
	"lineErrorIcon": `Editor-module__lineErrorIcon__aegmW`,
	"lineError": `Editor-module__lineError___ct36`,
	"error": `Editor-module__error__fzwV3`,
	"success": `Editor-module__success__dMBjL`,
	"warning": `Editor-module__warning__HNc_2`,
	"editorLineActions": `Editor-module__editorLineActions__x9tIj`,
	"autoPilotSVGContainer": `Editor-module__autoPilotSVGContainer__VVzCL`,
	"editorTab": `Editor-module__editorTab__q4JDD`,
	"hideTabNav": `Editor-module__hideTabNav__FslY2`,
	"autopilotScaleAnimation": `Editor-module__autopilotScaleAnimation__UOt5H`,
	"scale": `Editor-module__scale__nk7Tc`,
	"tab": `Editor-module__tab__omHfw`,
	"tabClose": `Editor-module__tabClose__Qm9ZO`,
	"foldIcon": `Editor-module__foldIcon__CDLaE`,
	"collapsedBlock": `Editor-module__collapsedBlock__w2Czm`
};
export default ___CSS_LOADER_EXPORT___;
